import { SHOW_VIDEO_CONTROL, HIDE_VIDEO_CONTROL } from '../actions/Playback';
const initialState = {
    showControls: true,
};
export function VideoNPVStateReducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_VIDEO_CONTROL:
            return Object.assign(Object.assign({}, state), { showControls: true });
        case HIDE_VIDEO_CONTROL:
            return Object.assign(Object.assign({}, state), { showControls: false });
        default:
            return state;
    }
}
